export default function Impact() {
  const challenges = [
    {
      icon: 'ri-water-flash-line',
      title: 'Aging and Failing Sewage Systems',
      description: 'Transforming infrastructure liabilities into revenue-generating assets'
    },
    {
      icon: 'ri-flashlight-line',
      title: 'Increasing Electricity Shortages',
      description: 'Generating clean renewable energy from waste streams'
    },
    {
      icon: 'ri-drop-line',
      title: 'Growing Water Scarcity',
      description: 'Recovering and purifying water for industrial and agricultural reuse'
    },
    {
      icon: 'ri-fire-line',
      title: 'Rising Methane Emissions',
      description: 'Capturing biogas to reduce greenhouse gas emissions'
    },
    {
      icon: 'ri-contrast-drop-line',
      title: 'Pollution from Industrial Wastewater',
      description: 'Converting pollutants into valuable resources and clean water'
    },
    {
      icon: 'ri-recycle-line',
      title: 'Unmanaged Organic Waste',
      description: 'Creating circular economy solutions that close resource loops'
    }
  ];

  const outcomes = [
    {
      icon: 'ri-shield-check-line',
      title: 'Strengthen Municipal Resilience',
      color: 'emerald'
    },
    {
      icon: 'ri-leaf-line',
      title: 'Reduce Greenhouse Gas Emissions',
      color: 'green'
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'Lower Operational Costs',
      color: 'amber'
    },
    {
      icon: 'ri-team-line',
      title: 'Create Green Industries and Jobs',
      color: 'blue'
    }
  ];

  return (
    <section id="impact" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-block bg-emerald-100 text-emerald-700 px-4 py-2 rounded-full text-sm font-semibold mb-6">
            Why We Exist
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Turning <strong>Systemic Problems</strong> into Bankable Solutions
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Across Africa, cities and industries face interconnected challenges. Kagesi Development transforms these problems into climate-positive infrastructure projects.
          </p>
        </div>

        <div className="mb-16">
          <h3 className="text-2xl font-bold text-gray-900 mb-8 text-center">Challenges We Address</h3>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {challenges.map((challenge, index) => (
              <div key={index} className="bg-white p-6 rounded-xl border border-gray-200 hover:shadow-lg transition-all">
                <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center mb-4">
                  <i className={`${challenge.icon} text-red-600 text-xl`}></i>
                </div>
                <h4 className="font-bold text-gray-900 mb-2">{challenge.title}</h4>
                <p className="text-sm text-gray-600 leading-relaxed">{challenge.description}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="bg-gradient-to-br from-emerald-600 to-green-700 rounded-2xl p-10 text-white">
          <h3 className="text-3xl font-bold mb-8 text-center">Our Impact</h3>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {outcomes.map((outcome, index) => (
              <div key={index} className="text-center">
                <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${outcome.icon} text-3xl`}></i>
                </div>
                <h4 className="font-bold text-lg">{outcome.title}</h4>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}